























import { Component, Vue, Prop } from 'vue-property-decorator';
import { ALL_PAYMENT_METHODS } from '@/queries/PaymentMethod';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { GQL_deletePaymentMethod_deletePaymentMethod_paymentMethod } from '@/queries/__generated__/deletePaymentMethod';
import { GQL_currentUnitPaymentMethods_currentUnit_paymentMethods, GQL_currentUnitPaymentMethods } from '@/queries/__generated__/currentUnitPaymentMethods';
import gql from 'graphql-tag';

const DELETE_PAYMENT_METHOD = gql`
  mutation deletePaymentMethod($id: ID!) {
    deletePaymentMethod(
      input: {
        id: $id,
      }
    ) {
      paymentMethod {
        id
      }
    }
  }
`;


@Component
export default class PaymentMethodDeleteButton extends Vue {
  @Prop() private paymentMethod!: GQL_currentUnitPaymentMethods_currentUnit_paymentMethods;
  private DELETE_PAYMENT_METHOD = DELETE_PAYMENT_METHOD;

  private removeFromCache(
    store: InMemoryCache,
    { data: { deletePaymentMethod: { paymentMethod } } }: {data: {deletePaymentMethod: { paymentMethod: GQL_deletePaymentMethod_deletePaymentMethod_paymentMethod }} },
  ) {
    const data = (store.readQuery({ query: ALL_PAYMENT_METHODS }) as GQL_currentUnitPaymentMethods);
    data.currentUnit.paymentMethods = data.currentUnit.paymentMethods.filter(c => c.id !== paymentMethod.id);
    store.writeQuery({ query: ALL_PAYMENT_METHODS, data });
  }

  private confirmDelete(confirmMutation: () => {}) {
    this.$sPopup.confirm('', {
      title: this.$t('PopupTitle.confirmDelete'),
      message: this.$t('PopupBody.confirmDelete', { thing: this.paymentMethod.name }),
      onConfirm: confirmMutation,
    });
  }
}
